import React from 'react';
import { seasonalBanners } from '../../data/websites';
export function FeelAlive() {
  return <section aria-labelledby="feel-alive" className="bg-brand-black px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-834" data-mp="3h8yquc5n2f26">
      <div className="grid items-center gap-12 lg:grid-cols-2 xl:gap-20" data-id="element-835" data-mp="3c9nav5d3jdln">
        <div data-id="element-836" data-mp="3893c5xcvk1xe">
          <h2 id="feel-alive" className="text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-white" data-id="element-837" data-mp="389lftf1v9ifc">
            Make your website <span className="text-brand-red" data-id="element-838" data-mp="3uvgbq1bk913">feel alive.</span>
          </h2>
          <p className="mt-6 max-w-[58ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-300" data-id="element-839" data-mp="3wy38176dm1l">
            Because changes are easy, you actually make them. A pizza place can dress up its site for Halloween, then
            Thanksgiving, then Christmas, without it being a project.
          </p>
          <p className="mt-4 text-[clamp(1.0625rem,1.2vw,1.375rem)] font-semibold text-white" data-id="element-840" data-mp="mthdittptfzq">
            New special? New hours? New service? Done in minutes.
          </p>
        </div>

        <ol className="space-y-4" aria-label="Example seasonal updates for a pizza place" data-id="element-841" data-mp="13u5gjojg5e9n">
          {seasonalBanners.map(banner => <li key={banner.month} className="flex items-stretch overflow-hidden rounded-xl border border-white/10" data-id="element-842" data-mp="u2rgnfnl2cfz">
              <span className="flex w-20 flex-shrink-0 items-center justify-center bg-white/5 text-sm font-bold uppercase tracking-[0.14em] text-gray-400" data-id="element-843" data-mp="yzro9v02zn97">
                {banner.month}
              </span>
              <p className={`flex-1 px-6 py-5 text-[clamp(1rem,1.2vw,1.375rem)] font-bold ${banner.tone}`} data-id="element-844" data-mp="q1z8yqud0flt">{banner.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}